import Swiper from 'swiper'
import SwiperCore, { Navigation, Lazy } from 'swiper/core'

export default class ArticleCardCarousel {
  constructor(component) {
    this.refs = {
      container: '.js-articleCardCarouselContainer',
      prev: '.js-articleCardCarouselPrev',
      next: '.js-articleCardCarouselNext',
      slides: '.js-slideContainer',
      link: '.js-link',
    }

    this.dom = {
      $component: component,
      $container: component.querySelector(this.refs.container),
      $slides: component.querySelectorAll(this.refs.slides),
    }

    this.state = {
      swiper: null,
    }

    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
  }

  linkClickHandler() {
    const { state } = this
    const slide = state.swiper.clickedSlide
    if (slide) this.urlRedirect(slide)
  }

  urlRedirect(element) {
    const link = element.querySelector(this.refs.link)

    if (link) window.open(link, '_blank')
  }

  initSlider() {
    const { dom, state, refs } = this

    if (dom.$container) {
      const { id } = dom.$container.dataset
      const ref = `${refs.container}.swiper-ref-${id}`
      state.swiper = new Swiper(ref, {
        slidesPerView: 1.175,
        spaceBetween: 24,
        loop: true,
        lazy: true,
        effect: 'fade',
        threshold: '25px',
        navigation: {
          prevEl: `${refs.prev}-${id}`,
          nextEl: `${refs.next}-${id}`,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
          1110: {
            slidesPerView: 3.9,
          },
        },
      })
      state.swiper.on('click', this.linkClickHandler.bind(this))
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ArticleCardCarousel = this
  }
}
